export const TEST_CREDENTIAL_CATEGORY = {
    SUCCESS: 'SUCCESS',
    CONNECTOR_ISSUE: 'CONNECTOR_ISSUE',
    PAYROLL_SYSTEM_CONFIGURATION_ISSUE: 'PAYROLL_SYSTEM_CONFIGURATION_ISSUE',
    USER_ISSUE: 'USER_ISSUE',
    SERVICE_PROVIDER_ISSUE: 'SERVICE_PROVIDER_ISSUE'
};
/**
 * Master list of test credential categories, used for grouping test credentials in our UI.
 */
export const TEST_CREDENTIAL_CATEGORIES = {
    [TEST_CREDENTIAL_CATEGORY.SUCCESS]: {
        title: 'Successful operation',
        description: "Test where the user's credentials are correct and the task completes. When answering MFA questions, any answer will be accepted."
    },
    [TEST_CREDENTIAL_CATEGORY.CONNECTOR_ISSUE]: {
        title: 'Error establishing connection',
        description: 'Test where the user encounters an issue connecting to the third-party system.'
    },
    [TEST_CREDENTIAL_CATEGORY.PAYROLL_SYSTEM_CONFIGURATION_ISSUE]: {
        title: 'Payroll system configuration',
        description: 'Test where the user encounters an issue with their payroll system configuration or access.'
    },
    [TEST_CREDENTIAL_CATEGORY.USER_ISSUE]: {
        title: 'User issue',
        description: 'Test where there is an error that occurs due to an action of the user.'
    },
    [TEST_CREDENTIAL_CATEGORY.SERVICE_PROVIDER_ISSUE]: {
        title: 'Service provider issue',
        description: 'Test where the user encounters an issue originating from the service provider.'
    }
};
//# sourceMappingURL=test-credential-categories.js.map